export default {
  name: 'FeatureSwitch',
  functional: true,
  props: {
    name: {
      type: String,
    },
    variant: {
      type: String,
    },
    data: {
      type: [Object, String],
    },
    tag: {
      type: String,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  render(createElement, context) {
    const api = context.parent.$featureApi

    if (
      context.props.show &&
      api &&
      api.isVisible(context.props.name, context.props.variant, context.props.data)
    ) {
      return context.props.tag
        ? createElement(context.props.tag, context.data, context.children)
        : context.slots().default
    }
  },
}
